<template>
  <div
    id="slide-2"
    @scroll.stop=""
    class="slide pt-37.5 px-23.5 pb-40 h-screen relative w-full grid grid-cols-2 gap-5 fz-16"
  >
    <service-wrapper image="loader" :title="text.services[0].title">
      <div class="flex flex-col items-end gap-1.25">
        <div class="flex gap-5 items-center service-items">
          <p class="text-left service-item " style="line-height: 1.5rem;">
            {{ text.services[0].points[0] }}
          </p>
          <img
              src="@/assets/images/slide_1/service_icons/cross.svg"
              class="inline w-5"
              alt=""
          />
        </div>
        <div class="flex gap-5 items-center service-items">
          <p class="text-left service-item " style="line-height: 1.5rem;">
            {{ text.services[0].points[1] }}
          </p>
          <img
              src="@/assets/images/slide_1/service_icons/cross.svg"
              class="inline w-5"
              alt=""
          />
        </div>
        <div class="flex gap-5 items-center service-items">
          <p class="text-left service-item " style="line-height: 1.5rem;">
            {{ text.services[0].points[2] }}
          </p>
          <img
              src="@/assets/images/slide_1/service_icons/cross.svg"
              class="inline w-5"
              alt=""
          />
        </div>

      </div>
    </service-wrapper>

    <service-wrapper image="globe" :title="text.services[1].title">
      <div class="flex flex-col items-end gap-1.25">
        <div class="flex gap-5 items-center service-items">
          <p class="text-left service-item " style="line-height: 1.5rem;">
            {{ text.services[1].points[0] }}
          </p>
          <img
              src="@/assets/images/slide_1/service_icons/cross.svg"
              class="inline w-5"
              alt=""
          />
        </div>
        <div class="flex gap-5 items-center service-items">
          <p class="text-left service-item " style="line-height: 1.5rem;">
            {{ text.services[1].points[1] }}
          </p>
          <img
              src="@/assets/images/slide_1/service_icons/cross.svg"
              class="inline w-5"
              alt=""
          />
        </div>
        <div class="flex gap-5 items-center service-items">
          <p class="text-left service-item " style="line-height: 1.5rem;">
            {{ text.services[1].points[2] }}
          </p>
          <img
              src="@/assets/images/slide_1/service_icons/cross.svg"
              class="inline w-5"
              alt=""
          />
        </div>

      </div>
    </service-wrapper>

    <service-wrapper image="radio" :title="text.services[2].title">
      <div class="flex flex-col items-end gap-1.25">
        <div class="flex gap-5 items-center service-items">
          <p class="text-left service-item " style="line-height: 1.5rem;">
            {{ text.services[2].points[0] }}
          </p>
          <img
              src="@/assets/images/slide_1/service_icons/cross.svg"
              class="inline w-5"
              alt=""
          />
        </div>
        <div class="flex gap-5 items-center service-items">
          <p class="text-left service-item " style="line-height: 1.5rem;">
            {{ text.services[2].points[1] }}
          </p>
          <img
              src="@/assets/images/slide_1/service_icons/cross.svg"
              class="inline w-5"
              alt=""
          />
        </div>
        <div class="flex gap-5 items-center service-items">
          <p class="text-left service-item " style="line-height: 1.5rem;">
            {{ text.services[2].points[2] }}
          </p>
          <img
              src="@/assets/images/slide_1/service_icons/cross.svg"
              class="inline w-5"
              alt=""
          />
        </div>

      </div>
    </service-wrapper>

    <service-wrapper image="pen-tool" :title="text.services[3].title">
      <div class="flex flex-col items-end gap-1.25">
        <div class="flex gap-5 items-center service-items">
          <p class="text-left service-item " style="line-height: 1.5rem;">
            {{ text.services[3].points[0] }}
          </p>
          <img
              src="@/assets/images/slide_1/service_icons/cross.svg"
              class="inline w-5"
              alt=""
          />
        </div>
        <div class="flex gap-5 items-center service-items">
          <p class="text-left service-item " style="line-height: 1.5rem;">
            {{ text.services[3].points[1] }}
          </p>
          <img
              src="@/assets/images/slide_1/service_icons/cross.svg"
              class="inline w-5"
              alt=""
          />
        </div>
        <div class="flex gap-5 items-center service-items">
          <p class="text-left service-item " style="line-height: 1.5rem;">
            {{ text.services[3].points[2] }}
          </p>
          <img
              src="@/assets/images/slide_1/service_icons/cross.svg"
              class="inline w-5"
              alt=""
          />
        </div>

      </div>
    </service-wrapper>

    <service-wrapper image="smile" :title="text.services[4].title">
      <div class="flex flex-col mt-auto w-50 ml-auto">
        <p style="line-height: 1.5rem; text-align: right">{{ text.services[4].points[0] }} {{ text.services[4].points[1] }}</p>

      </div>
    </service-wrapper>





  </div>
</template>

<script>
import serviceWrapper from "@/components/tablet/slide1/serviceWrapper";
import {mapMutations, mapState} from "vuex";

export default {
  name: "slide2",
  components: { serviceWrapper },
  computed: {
    text() {
      return require("@/assets/text/main/slide1/" + this.lang + ".json");
    },
    ...mapState(['lang'])
  },
  methods:{
    ...mapMutations(['setRoute']),
  },
  mounted() {
    console.log(this.text)
  }
};
</script>

<style lang="scss" scoped>
.news {
  .right {
    p {
      transition: all linear 0.3s;
      color: #c0c5d8;
    }
  }
  svg {
    margin-left: 0;
    margin-top: 1.25rem;
    transition: all linear 0.3s;
    path {
      transition: all linear 0.3s;

      stroke: #ff2e53;
    }
  }
}
.news:hover {
  svg {
    margin-left: 3.5rem;
    transition: all linear 0.3s;
    path {
      transition: all linear 0.3s;

      stroke: #ff2e53;
    }
  }
  .right {
    p {
      transition: all linear 0.3s;
      color: white;
    }
  }
}
</style>
